import React, { Component } from 'react';
import { ContainerDetails } from './ContainerDetails';
import ReactDOM from "react-dom";

export class ContainerDetailsCard extends Component{

    constructor(props){
        super(props);
        this.state = {
            containerList: [<ContainerDetails key={"1"} id={0} maxVehicles={5} maxCommodities={10}/>]
        };

        this.addContainer = this.addContainer.bind(this);
        this.removeContainer = this.removeContainer.bind(this);
    }

    // componentDidMount(){
    //     const node = ReactDOM.findDOMNode(this);
    //     node.scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
    // }

    addContainer = () =>    
    {
        var containerList = this.state.containerList;
        if(containerList.length < parseInt(this.props.maxContainers, 10))
        {
            containerList.push(<ContainerDetails key={containerList.length.toString()} id={containerList.length} 
                maxVehicles={5} maxCommodities={10}/>);
        }
        this.setState({containerList: containerList});
    }
    removeContainer = () =>    
    {
        var containerList = this.state.containerList;
        if(containerList.length > 0)
        {
            containerList = containerList.slice(0,containerList.length-1);
        }
        this.setState({containerList: containerList});
    }

    render(){
        var removeBtn;
        if(this.state.containerList.length > 1){
            removeBtn = 
                <button type="button" className="btn btn-danger" onClick={this.removeContainer}>
                    Remove Container {this.state.containerList.length}</button>
        }
        return(
            <div className="col-12">
                <div className="row">

                    <div className="col-12 mb-1 strong">
                        Total Containers: {this.state.containerList.length}
                    </div>

                    <div className="col-12 mb-1">
                        <button type="button" className="btn btn-success mr-1" onClick={this.addContainer}>Add Container</button>                        
                        {removeBtn}
                    </div>
                    {this.state.containerList.map(element => element)}                    
                </div>
            </div>
        )
    }

}